import styled, { css } from "styled-components";

type SelectedType = {
  selected?: boolean;
};

export const MoreIcon = styled.span<SelectedType>`
  margin: 0;
  color: ${(props) => (props.selected ? "#288EFD" : "#656565")};
  font-size: 1.3rem;
`;

type ContainerProps = {
  showTour: boolean;
};

export const Container = styled.header<ContainerProps>`
  display: flex;
  justify-content: space-between;
  background: #fff;
  padding: 19px 20px;
  position: sticky;
  top: 0;
  z-index: 20;
  -webkit-box-shadow: 0px 2px 100px -35px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 0px 2px 100px -35px rgba(0, 0, 0, 0.8);
  box-shadow: 0px 2px 100px -35px rgba(0, 0, 0, 0.8);

  @media (max-width: 1100px) {
    display: none;
  }

  ${({ showTour }) =>
    showTour &&
    css`
      position: relative;
      z-index: 1000;
    `}
`;

export const BoxTwoBars = styled.div`
  display: flex;
  flex-direction: row;
`;

export const BoxNameAddress = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: "Mangueira bold";
`;

export const BoxAddressBreadcrumb = styled.div`
  display: flex;
  flex-direction: row;
  flex-direction: column;
`;

export const Address = styled.div`
  font-size: 12px;
  color: #818181;
`;

export const Breadcrumb = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray};
  margin-top: 12px;
  margin-left: -16px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const TwoBars = styled.div`
  color: ${({ theme }) => theme.colors.blueClean};
  font-size: 16px;
  font-family: "Mangueira bold";
  margin-right: 5px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const BoxNotificationProfile = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ContentSearch = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 30px;
  background-color: #efefef;
  border-radius: 16px;
  position: relative;

  & svg {
    font-size: 20px;
    color: ${({ theme }) => theme?.colors?.primaryText};
    position: absolute;
    top: 5px;
    bottom: 0;
    left: 5px;
  }
`;

export const InputSearch = styled.input`
  width: 100%;
  height: 18px;
  font-size: 14px;
  padding-left: 30px;
  background-color: transparent;
  border: none;
  outline: none;
  color: ${({ theme }) => theme?.colors?.primaryText};
`;

export const BoxResponsiveMore = styled.div`
  display: none;
`;

export const ResponsiveGradient = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    align-items: center;
    padding: 10px 20px;
    border-radius: 5px;
    background: linear-gradient(#efefef, #ebebeb);
  }
`;

export const IntroButton = styled.button`
  background: ${({ theme }) => theme.colors.mediumPurple};
  color: #ffffff;
  border: none;
  border-radius: 4px;
  height: 25px;
  font-size: 12px;
  font-weight: 600;
  transition: 0.5s;
  outline: none !important;
  span {
    margin-right: 4px;
  }
  &:hover {
    background: #328cfd;
  }
`;

export const Separator = styled.div`
  height: 16px;
  border: 1px dashed #7a7a7a;
`;

export const ContainerWrap = styled.div`
  position: relative;
`;

export const ContentSearchWrap = styled.div`
  position: relative;
`;
